import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../../shared/shared.module';
import { InputDatePickerModule } from '../input-date-picker/input-date-picker.module';
import { InputDateRangePickerComponent } from './input-date-range-picker.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    InputDatePickerModule,
  ],
  declarations: [InputDateRangePickerComponent],
  exports: [InputDateRangePickerComponent],
})
export class InputDateRangePickerModule {}
